import { render, staticRenderFns } from "./panelItem.vue?vue&type=template&id=4347fdc1&scoped=true&"
import script from "./panelItem.vue?vue&type=script&lang=js&"
export * from "./panelItem.vue?vue&type=script&lang=js&"
import style0 from "./panelItem.vue?vue&type=style&index=0&id=4347fdc1&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4347fdc1",
  null
  
)

export default component.exports